import { Env } from '@/interfaces/env';

export const prodisPlatformUrls = {
  [Env.local]: 'https://localhost:3000',
  [Env.dev]: 'https://dev-app-23-agw-daisy-platform0001.azurewebsites.net',
  [Env.test]: 'https://portal.daisy-tst.bew.berlin',
  [Env.prod]: 'https://portal.daisy.bew.berlin',
};
